module.exports = __webpack_public_path__ + "img/icon11.c2d1fbfa.png";